import { DataSource, HorizontalSpacer, Label, Layout, Panel } from "@mcleod/components";

export abstract class AutogenLayoutSrcQuickInfo extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelLabel1: Label;
    labelStatusReasonCodeDescription: Label;
    panel1: Panel;
    sourceEdiStandardCode: DataSource;
}
